module.exports = __webpack_public_path__ + "static/media/Gps-On.d686c58e.svg";